export const COLOR = {
  WHITE: '#ffffff', // backgrounds/text
  BLACK: '#111111', // text
  RED: '#e91019', // text/borders/backgrounds
  BLUE: '#007EFF',
  BLUE_HOVER: '#3395FD',
  BLUE_BUTTON: '#2e87cf',
  GREY: '#747474',
  GRAY50: '#f5f5f5',
  GRAY200: '#d3d3d3',
  GREY_SUBHEADING: '#9c9c9c',
  GREY_BORDER: '#ccc',
  GREY_BORDER_ALT: '#f5f5f5',
  GREY_BACKGROUND: '#e2e2e2',
  LIGHTGREY: '#ebebeb', // typically used for borders
  LIGHTGREY2: '#f1f1f1',
  LIGHTGREY3: '#f7f7f7',
  LIGHTGREY4: '#a4a4a4',
  DARKGREY: '#333',
  DARKGREY2: '#777777',
  GRAYDARK: '#999',
  GRAYBORDER: '#ccc',
  GRAYMEDIUM: '#dedede',
  MEDGREY: '#ddd',
  SEPARATOR: '#d8d8d8',
  SEPARATOR2: '#c9c9c9',

  ARTICLE: '#f36b33',
  INTERVIEW: '#ffa21a',
  REPORT: '#e91019',
  AUDIO: '#fa5f93',
  VIDEO: '#944bbb',
  CHART: '#7a69e6',
  FORECASTS: '#27ceb6',

  TRENDING: '#f7575',
  BACKGROUND: '#ffffff',
  GREY_BLACK: '#333333',
  BLUE_BACKGROUND: '#1387ba',
  BLACK_BACKGROUND: '#000000',
  SOFTBLACK: '#555',
  BLUE_PRIMARY: '#2b7cac',
  GRAY_BACKGROUND: '#f2f2f2',

  DOWNLOADS: {
    DOCX: '#295596',
    EPUB: '#747474',
    FILE: '#fa5f93',
    GIF: '#B93D81',
    JPG: '#409FF1',
    PDF: '#e91019',
    PNG: '#FA9F1B',
    PPT: '#f36b33',
    XLS: '#207146',
  },
};

export const FONT = {
  COLOR: {
    BLACK: '#38393c',
    WHITE: '#FFF',
  },
  FAMILY: "'Lab Grotesque', Arial, sans-serif",
  FAMILYROBO: 'Roboto, sans-serif',
  FAMILYLABG: 'Lab Grotesque, sans-serif',
  LINEHEIGHT: '1.4',
  MOZFONTSMOOTHING: 'grayscale',
  SIZE: {
    DEFAULT: '16px',
  },
  STYLE: {
    BLACK: 'black',
    BOLD: 'bold',
    DEFAULT: 'normal',
    ITALIC: 'italic',
  },
  TEXTRENDERING: 'optimizeLegibility',
  WEBKITFONTSMOOTHING: 'antialiased',
  WEIGHT: {
    BLACK: 900,
    BOLD: 700,
    DEFAULT: 400,
    LIGHT: 400,
  },
};

export const TYPOGRAPHY = {
  LIGHT: `
    font-family: ${FONT.FAMILYLABG};
    font-weight: ${FONT.WEIGHT.DEFAULT};
    font-style: ${FONT.STYLE.DEFAULT};
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  `,
  BOLD: `
    font-family: ${FONT.FAMILYLABG};
    font-weight: ${FONT.WEIGHT.BOLD};
    font-style: ${FONT.STYLE.DEFAULT};
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  `,
  BLACK: `
   font-family: ${FONT.FAMILYLABG};
    font-weight: ${FONT.WEIGHT.BLACK};
    font-style: ${FONT.STYLE.DEFAULT};
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  `,
};

export const LAYOUT = {
  WIDTH: {
    DEFAULT: 'max-width: 1170px',
    WIDE: 'max-width: 1360px',
  },
  BREAKPOINT: {
    DESKTOP: 'min-width: 992px',
    MEDIUM: 'min-width: 1200px',
    ULTRA: 'min-width: 1440px',
  },
};
export const DROPSHADOW = {
  DEFAULT: `
   -webkit-box-shadow: 0 4px 20px 4px rgba(0, 0, 0, 0.05);
   -moz-box-shadow: 0 4px 20px 4px rgba(0, 0, 0, 0.05);
   box-shadow: 0 4px 20px 4px rgba(0, 0, 0, 0.05);
   `,
};
